import React, { useState } from "react";
import {
  ChevronDown,
  ChevronRight,
  CheckCircle,
  RefreshCw,
  Circle,
} from "lucide-react";
import "./AgentExecutionPanel.scss";

/**
 * Real-time todo list progress display for agent execution
 * Shows all todos with status icons and current task highlighted
 */
const AgentTodoList = ({ todos, currentTask }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const getStatusConfig = (status) => {
    switch (status) {
      case "completed":
        return { Icon: CheckCircle, className: "completed", spinning: false };
      case "in_progress":
        return { Icon: RefreshCw, className: "in-progress", spinning: true };
      case "pending":
      default:
        return { Icon: Circle, className: "pending", spinning: false };
    }
  };

  const completedCount = todos.filter((t) => t.status === "completed").length;

  if (!todos || todos.length === 0) {
    return null;
  }

  return (
    <div className="agent-todo-list">
      <div
        className="todo-header"
        onClick={() => setIsExpanded(!isExpanded)}
        role="button"
        tabIndex={0}
      >
        {isExpanded ? (
          <ChevronDown size={18} className="expand-icon" />
        ) : (
          <ChevronRight size={18} className="expand-icon" />
        )}
        <span className="header-text">
          Tasks ({completedCount}/{todos.length})
        </span>
      </div>

      {isExpanded && (
        <div className="todo-items">
          {todos.map((todo, index) => {
            const statusConfig = getStatusConfig(todo.status);
            const { Icon } = statusConfig;
            const isCurrent = currentTask === todo.content;

            return (
              <div
                key={index}
                className={`todo-item ${statusConfig.className} ${isCurrent ? "current" : ""}`}
              >
                <Icon
                  size={18}
                  className={`todo-icon ${statusConfig.spinning ? "spinning" : ""}`}
                />
                <div className="todo-content">
                  <span className="todo-text">
                    {todo.status === "in_progress" ? todo.activeForm : todo.content}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AgentTodoList;
